<app-progress-spinner [show]="isLoading"></app-progress-spinner>
<div class="success-metrics">
  <div class="period-bar">
    <app-ai-month-stepper [label]="monthLabel" [canStepForward]="canStepForward" (step)="stepMonth($event)">
    </app-ai-month-stepper>
    <span class="period-note">{{ 'all tenants with the analyst on' | translate }}</span>
  </div>

  @if (summary) {
    <div class="metric-card-grid">
      <div class="metric-card metric-card-wide">
        <span class="metric-card-title">{{ 'Credits per day' | translate }}</span>
        <div class="credits-body">
          <div class="credits-totals">
            <div class="metric">
              <span class="metric-value">{{ summary.totalCreditsConsumed | number:'1.2-2' }}</span>
              <span class="metric-label">{{ 'credits this month' | translate }}</span>
            </div>
            <div class="metric metric-positive">
              <span class="metric-value">{{ summary.creditsPerActiveUser | number:'1.2-2' }}</span>
              <span class="metric-label">{{ 'per active user' | translate }}</span>
            </div>
          </div>
          <app-credits-per-day-chart [month]="month" [dailyCredits]="summary.dailyCredits"></app-credits-per-day-chart>
        </div>
      </div>

      <div class="metric-card">
        <span class="metric-card-title">{{ 'Adoption' | translate }}</span>
        <div class="metric">
          <span class="metric-value">{{ summary.adoptedUserCount }}
            <span class="metric-of">{{ 'of' | translate }} {{ summary.activeLicensedUserCount }}</span>
          </span>
          <span class="metric-label">{{ 'licensed users asked something' | translate }}</span>
        </div>
        <div class="meter"><i [style.width.%]="summary.adoptionRate * 100"></i></div>
        <span class="metric-card-caption">{{ '{{percent}} adoption' | translate:{ percent: (summary.adoptionRate | percent:'1.0-0') } }}</span>
      </div>

      <div class="metric-card">
        <span class="metric-card-title">{{ 'Questions vs reports' | translate }}</span>
        <div class="metric">
          <span class="metric-value">{{ answerSplit.total }}</span>
          <span class="metric-label">{{ 'answers this month' | translate }}</span>
        </div>
        <div class="split">
          <i class="split-questions" [style.width.%]="answerSplit.questionPercent"></i>
          <i class="split-reports" [style.width.%]="answerSplit.reportPercent"></i>
        </div>
        <span class="metric-card-caption">
          <span class="swatch swatch-questions"></span>{{ answerSplit.questionCount }} {{ 'questions' | translate }}
          <span class="swatch swatch-reports"></span>{{ summary.reportsGeneratedCount }} {{ 'reports' | translate }}
        </span>
      </div>

      <div class="metric-card">
        <span class="metric-card-title">{{ 'Satisfaction' | translate }}</span>
        <div class="metric">
          @if (ratedCount) {
            <span class="metric-value">{{ summary.satisfactionRate | percent:'1.0-0' }}</span>
            <span class="metric-label">{{ 'thumbs up' | translate }}</span>
          } @else {
            <span class="metric-value">&mdash;</span>
            <span class="metric-label">{{ 'no ratings this month' | translate }}</span>
          }
        </div>
        <div class="split">
          @if (ratedCount) {
            <i class="split-questions" [style.width.%]="thumbsUpPercent"></i>
            <i class="split-reports" [style.width.%]="thumbsDownPercent"></i>
          } @else {
            <i class="split-placeholder"></i>
          }
        </div>
        <span class="metric-card-caption">
          <mat-icon class="thumb-icon">thumb_up</mat-icon>{{ summary.thumbsUpCount }}
          <mat-icon class="thumb-icon">thumb_down</mat-icon>{{ summary.thumbsDownCount }}
        </span>
      </div>

      <div class="metric-card">
        <span class="metric-card-title">{{ 'Time saved' | translate }}</span>
        <div class="metric">
          <span class="metric-value">
            @if (summary.averageTimeToAnswerMs !== null) {
              {{ summary.averageTimeToAnswerMs / 1000 | number:'1.1-1' }} s
            } @else {
              &mdash;
            }
          </span>
          <span class="metric-label">{{ 'Average time to answer' | translate }}</span>
        </div>
        <div class="metric metric-secondary">
          <span class="metric-value metric-value-small">
            @if (summary.averageSelfReportedMinutesSaved !== null) {
              {{ summary.averageSelfReportedMinutesSaved | number:'1.0-1' }} min
            } @else {
              &mdash;
            }
          </span>
          <span class="metric-label">{{ 'Average minutes saved (user estimate)' | translate }}</span>
        </div>
      </div>
    </div>
  }
</div>
